import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { ChipListSelectSearchComponent } from '@pishgamrayan/ng-form-kit';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

import { ShareDirectivesModule } from 'src/app/core/directives/directives.module';
import { SharePipesModule } from 'src/app/core/pipes/pipes.module';
import { TranslationModule } from 'src/app/i18n';
import { ChipListSelectSearchComponent } from '../../form-kit/chip-list-select-search/chip-list-select-search.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    TranslationModule,
    NgxMaterialTimepickerModule,
    ShareDirectivesModule,
    MatOptionModule,
    SharePipesModule,
    MatTooltipModule,
    ChipListSelectSearchComponent,
  ],
  exports: [
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    TranslationModule,
    NgxMaterialTimepickerModule,
    ShareDirectivesModule,
    MatOptionModule,
    SharePipesModule,
    MatTooltipModule,
    ChipListSelectSearchComponent,
  ],
})
export class BaseApiChipListSelectSearchModule {}
